import UserProfile from "./views/UserProfile/UserProfile";
import AdminSettings from "./views/UserProfile/AdminSettings";
import { PartnersList } from "./Components/Partners/PartnersList";
import { ClientsList } from "Components/Clients/ClientsList";
import { Surveys } from "./Components/Surveys/Surveys";
import { PeopleTwoTone, Dashboard, AccountCircle, ListAlt, Business, Security, Assessment, DeleteForever, Edit, SupervisorAccount, Assignment, Block } from "@material-ui/icons";
import { DashboardSurvey } from "./Components/Surveys/DashboardSurvey";
import { SurveyDetailPage } from "./Components/Surveys/SurveyDetailPage";
import { SurveyCreatePage } from "./Components/Surveys/SurveyCreatePage";
import AdminDashboard from "./views/Dashboard/AdminDashboard";
import { PMDashboard } from "./Components/Dashboard/PMDashboard";
import {SurveyStatus} from "./Components/SurveyRewardsOverview/SurveyStatus";
import PreScreen from "Components/PreScreen/PreScreen";
import SurveyHold from "./Components/SurveyHold/SurveyHold";
import PartnerSurvey from "./Components/Partners/PartnerSurvey";
import { PartnerClientAnalysis } from "./Components/Partners/PartnerClientAnalysis";
import { AllPanelists } from "./Components/Panelists/AllPanelists";
import ChangeLogPage from "./Components/ChangeLog/ChangeLogPage";
import UserManagement from "./views/UserManagement/UserManagement";

// The six roles from the XING module sheet; there is no sub-admin role.
const ALL_ROLES = ['super_admin', 'admin', 'tl', 'pm', 'sales', 'finance'];

// Base route definitions mapping to standard DataXing components
const routeDefinitions = [
  {
    path: "/dashboard",
    name: "Dashboard",
    hindi: "डैशबोर्ड",
    icon: Dashboard,
    component: PMDashboard,
    roles: ['super_admin', 'admin', 'tl', 'pm', 'sales']
  },
  {
    // SCRUM-34: Surveys and Schedule Survey merged into one page.
    path: "/surveys",
    exact: true,
    name: "Surveys",
    hindi: "सर्वे",
    icon: ListAlt,
    component: DashboardSurvey,
    roles: ['super_admin', 'admin', 'tl', 'pm', 'sales']
  },
  {
    path: "/partners",
    name: "Partners",
    hindi: "साथी",
    icon: Business,
    component: PartnersList,
    roles: ['super_admin', 'admin', 'tl', 'pm', 'sales']
  },
  {
    path: "/clients",
    name: "Clients",
    hindi: "ग्राहक",
    icon: PeopleTwoTone,
    component: ClientsList,
    roles: ['super_admin', 'admin', 'tl', 'pm', 'sales']
  },
  {
    path: "/survey-overview",
    name: "Survey Overview",
    hindi: "सर्वे अवलोकन",
    icon: Dashboard,
    component: SurveyStatus,
    roles: ['super_admin', 'admin', 'tl', 'pm', 'sales']
  },
  {
    path: "/preScreenQuesAns",
    name: "PreScreen Questions",
    hindi: "परिस्कर्ीन सवाल",
    icon: Security,
    component: PreScreen,
    roles: ['super_admin', 'admin', 'tl', 'pm', 'sales']
  },
  {
    path: "/change-logs",
    name: "Change Log",
    hindi: "परिवर्तन लॉग",
    icon: Assignment,
    component: ChangeLogPage,
    roles: ['super_admin', 'admin', 'tl', 'pm', 'sales']
  },
  {
    path: "/partner-po",
    name: "Partner PO",
    hindi: "साझेदार पीओ",
    icon: Assignment,
    component: PartnerSurvey,
    roles: ['super_admin', 'admin', 'tl', 'pm', 'sales', 'finance']
  },
  {
    path: "/preScreenQuesEdit",
    name: "PreScreen Questions Edit",
    hindi: "परिस्कर्ीन सवाल संपादन",
    icon: Edit,
    component: PreScreen,
    roles: ['super_admin', 'admin', 'tl', 'pm', 'sales']
  },
  {
    path: "/reports",
    name: "Reports Page",
    hindi: "रिपोर्ट पृष्ठ",
    icon: Assessment,
    component: AdminDashboard,
    roles: ['super_admin', 'admin', 'tl']
  },
  {
    path: "/partner-client-analysis",
    name: "Partner Client Analysis",
    hindi: "साझेदार ग्राहक विश्लेषण",
    icon: Assessment,
    component: PartnerClientAnalysis,
    roles: ['super_admin', 'admin', 'tl']
  },
  {
    path: "/deletion-of-projects",
    name: "Deletion of Projects",
    hindi: "परियोजनाओं का विलोपन",
    icon: DeleteForever,
    component: Surveys,
    roles: ['super_admin', 'admin']
  },
  {
    path: "/access-control",
    name: "Access Control for All",
    hindi: "सभी के लिए एक्सेस नियंत्रण",
    icon: SupervisorAccount,
    component: AllPanelists,
    roles: ['super_admin']
  },
  // Survey Exclusion is mentioned as pm only in original, let's keep it for super_admin, admin, tl, pm, sales
  {
    path: "/survey-exclusion",
    name: "Survey Exclusion",
    hindi: "सर्वे बहिष्करण",
    icon: Block,
    component: SurveyHold,
    roles: ['super_admin', 'admin', 'tl', 'pm', 'sales']
  }
];

const utilityRoutes = [
  {
    path: "/user-management",
    name: "User Management",
    hindi: "उपयोगकर्ता प्रबंधन",
    icon: SupervisorAccount,
    component: UserManagement,
    roles: ['super_admin', 'admin', 'tl']
  },
  {
    path: "/profile",
    name: "User Profile",
    hindi: "उपयोगकर्ता प्रोफ़ाइल",
    icon: AccountCircle,
    component: UserProfile,
    isVisible: false,
    roles: ALL_ROLES
  },
  {
    path: "/settings",
    name: "Settings",
    hindi: "सेटिंग्स",
    icon: AccountCircle,
    component: AdminSettings,
    isVisible: false,
    roles: ALL_ROLES
  },
  {
    path: "/surveys/details/:id",
    name: "Survey Details",
    hindi: "सर्वे विवरण",
    icon: ListAlt,
    component: SurveyDetailPage,
    isVisible: false,
    roles: ['super_admin', 'admin', 'tl', 'pm', 'sales']
  },
  {
    // SCRUM-34: Create Survey page (was a modal on /surveys). Same roles that see
    // the list's Create button: everyone on /surveys except sales.
    path: "/surveys/new",
    exact: true,
    name: "Create Survey",
    hindi: "सर्वे बनाएं",
    icon: ListAlt,
    component: SurveyCreatePage,
    isVisible: false,
    roles: ['super_admin', 'admin', 'tl', 'pm']
  }
];

let dashboardRoutes = [];

// For each role, build their specific routes with layout and type prefixes
ALL_ROLES.forEach(role => {
  const layoutPrefix = `/${role}`;
  
  routeDefinitions.forEach(route => {
    if (route.roles.includes(role)) {
      dashboardRoutes.push({ ...route, layout: layoutPrefix, type: role });
    }
  });

  utilityRoutes.forEach(route => {
    if (route.roles.includes(role)) {
      dashboardRoutes.push({ ...route, layout: layoutPrefix, type: role });
    }
  });
});

export default dashboardRoutes;


